<template>
  <div>
    <div class="source">
      <el-row class="querypanel" style="padding: 30px;">
        <el-col :span="12">
          <el-form   label-width="120px" label-position="left">
            <el-form-item label="群组名称:" >
              <el-input v-model="qzname" placeholder="请输入群组名称"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="24">
          <div>
            <el-button style="margin-top: 10px;" @click="addnewqz">添加新群组</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row class="querypanel">
        <el-col :span="24">
          <el-table
            stripe
            :data="qzdata"
            ref="multipleTable">
            <el-table-column
              min-width="30px"
              prop="id.Int64"
              label="群组编号"
            >
            </el-table-column>
            <el-table-column
              prop="name.String"
              label="群组名称">
            </el-table-column>
            <el-table-column
              label="操作"
              width="80px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="移除该群组" placement="top-start">
                  <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removeqz(scope.$index, qzdata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'CustomerGroupMana',
  data () {
    return {
      khid: '',
      qzdata: [],
      qzname: ''
    }
  },
  mounted: function () {
    that = this
    console.log(that)
    var v = getCookie('cusid')
    this.khid = v
    that = this
    that.$options.methods.queryqz()
  },
  methods: {
    addnewqz () {
      if (this.hyname !== '') {
        var idata = {
          name: {String: that.qzname, Valid: true},
          parentid: parseInt(-1),
          level: parseInt(1),
          haschild: parseInt(0)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/aaubcgi',
          method: 'post',
          data: idata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              var objtmp = JSON.parse(res.data.data)
              that.$message({
                type: 'success',
                message: '添加成功!'
              })
              that.$options.methods.queryqz()
              console.log(objtmp)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    removeqz (index, data) {
      var selectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === selectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/dbcgi',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryqz () {
      var qstr = 'id>0'
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/gbcgi',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            var objtmp = JSON.parse(res.data.data)
            console.log(objtmp)
            that.qzdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/cus/CustomerGroupMana.vue